module.exports = __webpack_public_path__ + "img/ics_o_shipping_service.858af343.svg";